import { useParams } from 'react-router-dom';
import { AttemptGradeView } from '@sphere/learning/ui';
import tw from './AttemptGradeViewPage.tailwind.module.scss';

/**
 * Page de notation d'une tentative
 * Wrapper simple qui extrait l'attemptId des paramètres de route
 */
export const AttemptGradeViewPage: React.FC = () => {
  const { attemptId } = useParams<{ attemptId: string }>();

  if (!attemptId) {
    return (
      <div className={tw.u1}>
        <p className={tw.u2}>Identifiant de tentative manquant</p>
      </div>
    );
  }

  return <AttemptGradeView attemptId={attemptId} />;
};

export default AttemptGradeViewPage;
